import './App.css';
import Project from './components/Project';

function App() {
  return (
    <div className="App">
      <Project />
    </div>
  );
}

export default App;
